"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = ['cs', 'da', 'de', 'en', 'es', 'es-mx', 'fi', 'fr', 'it', 'ja', 'nl', 'no-no', 'pl', 'pt-br', 'sv', 'zh-cn', 'zh-hk'];
exports.default = _default;
module.exports = exports.default;